module.exports = __webpack_public_path__ + "img/team-seadevils@2x.ebd11183.png";